import React from 'react';
import { Outlet } from 'react-router-dom';

import MetaTags from '@components/MetaTags';
import { useCurrentUser } from '@hooks';

import ForumHeader from '../ForumHeader';
import styles from './styles.module.scss';

export const FORUM_BASE_TITLE = 'The Information Forum';
const OG_IMAGE_PATH = '/global/og_images/forum_social_cover.png';
const DESCRIPTION =
  'The Information has a simple mission: deliver important, deeply reported stories about the technology business you won’t find elsewhere. Many of the most influential people in the industry turn to us for fresh information and original insight.';

export default function ForumLayout() {
  const { currentUser } = useCurrentUser();

  return (
    <div className={styles.forumLayout}>
      <MetaTags title={FORUM_BASE_TITLE} description={DESCRIPTION} ogImagePath={OG_IMAGE_PATH} />
      <ForumHeader currentUser={currentUser} />
      <Outlet />
    </div>
  );
}
